<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad">
      <template slot="menuLeft">
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.cleantask_delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>
      <template slot="status" slot-scope="scope">
        <el-tag :class="getClass(scope.row.status)">{{
          scope.row.status === 1 ? '正常' : '停用'
          }}</el-tag>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
  import {add, getDetail, getList, remove, update} from "@/api/v4ward/cleantask/cleantask";
  import {mapGetters} from "vuex";

  export default {
    data() {
      return {
        form: {},
        query: {},
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
          height: 'auto',
          calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          index: true,
          viewBtn: true,
          selection: true,
          dialogClickModal: false,
          dialogWidth: 600,
          indexLabel: '序号',
          columnBtn: false,
          align: 'center',
          column: [
            {
              label: "工单编号",
              prop: "code",
              rules: [{
                required: true,
                message: "请输入主键",
                trigger: "change"
              }]
            },
            {
              label: "项目名称",
              prop: "projectId",
              type: 'select',
              dicUrl: 'api/v4ward/project/getProjectList',
              editDisabled: true,
              search: true,
              props: {
                label: 'name',
                value: 'id',
              },
              rules: [{
                required: true,
                message: "请选择项目名称",
                trigger: "change"
              }]
            },
            {
              label: "描述",
              prop: "description",
              rules: [{
                required: true,
                message: "请输入描述",
                trigger: "change"
              }]
            },
            {
              label: "工单状态",
              prop: "workStatus",
              type: "select",
              dicUrl: '/api/blade-system/dict/dictionary?code=order_work_status',
              search: true,
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dataType: 'number',
              rules: [{
                required: true,
                message: "请选择工单状态",
                trigger: "change"
              }]
            },
            {
              label: "状态",
              prop: "status",
              type: "select",
              slot: true,
              dicData: [
                { label: '停用', value: 0 },
                { label: '启用', value: 1 },
              ],
            },
          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.cleantask_add, true),
          viewBtn: this.vaildData(this.permission.cleantask_view, false),
          delBtn: this.vaildData(this.permission.cleantask_delete, false),
          editBtn: this.vaildData(this.permission.cleantask_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    methods: {
      getClass(status) {
        if (status === 1) {
          return 'status-1';
        } else {
          return 'status-0';
        }
      },
      rowSave(row, done, loading) {
        add(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
          });
        }
        done();
      },
      searchReset() {
        this.query = {};
        this.onLoad();
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
    }
  };
</script>

<style>
  .status-1 {
    background-color: #daffde;
    color: green;
  }
  .status-0{
    background-color: #ffffff;
    color: #b5b5b5;
  }
</style>
